<template>
    <div>
        <div class="shop_list_container">
            <div class="shop_list_cont_sp">
                <div :id="mapId" class="" style="width: 100%; height: 450px !important;"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name    : 'vacancy-map',
    props   : {
        shops: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            map  : {},
            mapId: 'ymap_' + moment().unix() + '_2',
            test : 0,
        };
    },
    mounted() {
        this.initMap();
    },
    computed: {
        geoData: () => vxCommonStore.state.geoData,
    },
    methods : {
        initMap() {
            let geoObjects = [];
            $('#' + this.mapId).html('');

            this.$root.initMap(() => {
                ymaps.ready(() => {

                    //центр вычисляем на основе средних значений
                    let totalCoordinates = {
                        lat: 0,
                        lng: 0,
                        cnt: 0,
                    };

                    for (let shop of this.shops) {
                        if (!shop || !shop.SHOP_DATA || !shop.SHOP_DATA.COORDINATES || !shop.SHOP_DATA.COORDINATES.LAT || !shop.SHOP_DATA.COORDINATES.LNG) {
                            continue;
                        }
                        totalCoordinates.lat += +shop.SHOP_DATA.COORDINATES.LAT;
                        totalCoordinates.lng += +shop.SHOP_DATA.COORDINATES.LNG;
                        totalCoordinates.cnt++;
                    }



                    let center = [
                        totalCoordinates.lat/totalCoordinates.cnt,
                        totalCoordinates.lng/totalCoordinates.cnt,
                    ];



                    this.map = new ymaps.Map(this.mapId, {
                        center  : center,
                        zoom    : 11,
                        controls: ['fullscreenControl'],
                    });

                    for (let shop of this.shops) {

                        if (!shop || !shop.SHOP_DATA || !shop.SHOP_DATA.COORDINATES || !shop.SHOP_DATA.COORDINATES.LAT || !shop.SHOP_DATA.COORDINATES.LNG) {
                            continue;
                        }

                        let mapIcon;
                        if (~vxCommonStore.state.selectedShops.indexOf(+shop.id)) {
                            mapIcon = '/local/templates/.default/img/kb_red_check_box_2.png';
                        } else {
                            mapIcon = '/local/templates/.default/img/kb_pin.png';
                        }

                        shop.balloonContent = _.template(`
                            <div class="shop_balloon">
                                <div class="shop_balloon__title">
                                    <%- shop.SHOP_DATA.NAME %>
                                </div>
                                <div class="shop_balloon__rezhim">
                                    <b>Вакансии магазина</b>
                                    <ul>
                                        <% for (let vacancy of shop.VACANCIES) { %>
                                            <li><%- vacancy.NAME %></li>
                                        <% } %>
                                    </ul>
                                </div>
                                <div class="shop_balloon__check">
                                    <a href="https://krasnoeibeloe.ru/about/job/?FILTER[PROPERTY_SHOP_XML_IDS]=<%- shop.SHOP_DATA.XML_ID %>&form_id=vacancies_filter_form" target="_blank" class="btn btn_blue btn--shop_balloon_check">Выбрать&nbsp;магазин</a>
                                </div>
                            </div>
                        `)({ shop });

                        let shopCoordinates = [+shop.SHOP_DATA.COORDINATES.LAT, +shop.SHOP_DATA.COORDINATES.LNG];

                        let placemark = new ymaps.Placemark(
                            shopCoordinates, {
                                balloonContent: shop.balloonContent,
                            }, {
                                iconLayout   : 'default#image',
                                iconImageHref: mapIcon,
                                iconImageSize: [28, 33],
                            },
                        );
                        placemark.shop = shop;
                        placemark.map_icon = mapIcon;
                        placemark.map_icon_selected = '/local/templates/.default/img/kb_red_check_box_2.png';


                        geoObjects.push(placemark);
                    }


                    let clusterer = new ymaps.Clusterer({
                        preset    : 'islands#redClusterIcons',
                        hasBalloon: false,
                        gridSize  : 80,
                    });

                    clusterer.add(geoObjects);
                    this.map.geoObjects.add(clusterer);

                    this.map.setBounds(clusterer.getBounds(), {
                        checkZoomRange: true,
                    });
                });
            });
        },
    },
};
</script>
